/**
 * Survey API React Query Hooks
 */

import { useQuery, useMutation } from '@tanstack/react-query'
import {
  getActiveSurvey,
  submitSurveyResponse,
  getHomepageReviews,
} from './api'
import type { SurveyTrigger, SubmitSurveyRequest } from './api'
import { useAuthStore } from '@/stores/auth'
import { queryKeys } from '@/services/query-keys'

export function useActiveSurvey(trigger?: SurveyTrigger, enabled = true) {
  const { isAuthenticated, _hasHydrated } = useAuthStore()

  return useQuery({
    queryKey: queryKeys.surveys.active(trigger),
    queryFn: () => getActiveSurvey(trigger),
    enabled: _hasHydrated && isAuthenticated && enabled,
    staleTime: 5 * 60 * 1000,
  })
}

export function useSubmitSurvey() {
  return useMutation({
    mutationFn: ({
      surveyId,
      data,
    }: {
      surveyId: string
      data: SubmitSurveyRequest
    }) => submitSurveyResponse(surveyId, data),
  })
}

export function useHomepageReviews(limit: number = 10) {
  return useQuery({
    queryKey: queryKeys.surveys.homepageReviews(limit),
    queryFn: () => getHomepageReviews(limit),
    staleTime: 10 * 60 * 1000,
  })
}
